import { render } from "./ShareAchievement.vue?vue&type=template&id=a047aed6&scoped=true"
import script from "./ShareAchievement.vue?vue&type=script&lang=js"
export * from "./ShareAchievement.vue?vue&type=script&lang=js"

import "./ShareAchievement.vue?vue&type=style&index=0&id=a047aed6&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a047aed6"]])

export default __exports__